import React, { useEffect, useState } from "react";

const HERO_IMAGES = [
  {
    src: "1.png",
    alt: "black friday",
  },
  {
    src: "2.png",
    alt: "black friday",
  },
  {
    src: "3.png",
    alt: "black friday",
  },
  {
    src: "4.png",
    alt: "black friday",
  },
  {
    src: "5.png",
    alt: "black friday",
  },
];

const ROTATION_INTERVAL_MS = 5000;

const HeroImageRotator = ({ className = "img-hero" }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex((prev) => (prev + 1) % HERO_IMAGES.length);
    }, ROTATION_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, []);

  const current = HERO_IMAGES[index];

  return (
    <img
      src={"/heros/" + current.src}
      alt={current.alt}
      className={className}
    />
  );
};

export default HeroImageRotator;
